/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Skeleton } from '@mantine/core';

export default function WalletLoading() {
  return (
    <>
      <div className="w-full h-36 flex justify-between items-center gap-2.5 py-3 px-7">
        <div className="text-[#3A3A3A] font-semibold text-[26px] dark:text-[#F2F2F2]">
          <Skeleton width={120} height={25} />
        </div>
        <div className="text-[#3A3A3A] font-semibold text-[26px] dark:text-[#F2F2F2]">
          <Skeleton width={450} height={90} />
        </div>
        <div className="flex flex-col gap-2 text-[#3A3A3A] font-semibold text-[26px] dark:text-[#F2F2F2]">
          <Skeleton width={100} height={20} />
          <span className="text-[#2C66B8] dark:text-[#33B1FF] font-bold text-lg">
            <Skeleton width={120} height={14} />
          </span>
        </div>
      </div>
    </>
  );
}
